import { Button } from '@mui/material';
import { appRoutes } from 'constants/routes.constant';
import { useNavigate } from 'react-router-dom';
import svg from './404.svg';
import AppStateStyles from './styles';
const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <AppStateStyles.Container>
        <img src={svg} alt="svg" />
        <Button variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => navigate(appRoutes.LANDING)}>
          Back to home
        </Button>
      </AppStateStyles.Container>
    </>
  );
};

export default PageNotFound;
